<template>
  <div>
    <template v-for="(fields, section) in groupedFields" :key="section">
      <patient-section v-if="shouldShowCustomSection(section)" :title="section" :has-required-field="hasRequiredField(fields)" :is-open="getSectionState(section)" @update:isOpen="updateSectionState(section, $event)">
        <div class="columns is-flex-wrap-wrap">
          <template v-for="field in fields" :key="field.key">
            <div v-if="shouldShowCustomField(field)" class="column is-6">
              <component :read-only="readOnly" :is="`${field.kind}-element-renderer`" v-bind="field" v-model="localValues[field.key]">
              </component>
            </div>
          </template>

        </div>
      </patient-section>
    </template>
  </div>
</template>

<script>
import RendererComponents from "@/components/form_builder/RendererComponents";
import {toRaw} from "vue";
import PatientSection from "@/components/patient_overview/PatientSection.vue";


export default {
  name: "CustomFieldsRenderer",
  components: {PatientSection, ...RendererComponents },
  props: ['model', 'values', 'modelValue', 'readOnly', 'fieldVisibility', 'isSidebar', 'sectionStates'],
  beforeMount() {
    this.availableCustomFields = Object.values(this.$store.getters["CustomFieldsStore/getFieldsFor"](this.model))
  },
  methods: {
    hasRequiredField(fields) {
      return fields.some(f => f?.options?.validation?.isRequired)
    },
    shouldShowCustomField(field) {
      if (!this.fieldVisibility) return true
      
      const fieldKey = `custom_${field.key}`
      const fieldConfig = this.fieldVisibility.fields[fieldKey]
      
      if (!fieldConfig) return true
      
      return fieldConfig.visible
    },
    shouldShowCustomSection(sectionName) {
      if (!this.fieldVisibility || !sectionName) return true
      
      return this.customSectionHasVisibleFields(sectionName)
    },
    customSectionHasVisibleFields(sectionName) {
      if (!this.fieldVisibility || !sectionName) return true

      const sectionFields = this.groupedFields[sectionName] || []
      return sectionFields.some(field => this.shouldShowCustomField(field))
    },
    getSectionState(section) {
      const key = `custom_${section}`
      if (!this.sectionStates) return this.isSidebar ? true : false
      return this.sectionStates[key] !== undefined ? this.sectionStates[key] : (this.isSidebar ? true : false)
    },
    updateSectionState(section, value) {
      if (this.sectionStates) {
        const key = `custom_${section}`
        this.$emit('update:sectionStates', { ...this.sectionStates, [key]: value })
      }
    }
  },
  computed: {
    localValues: {
      get() {
        return this.modelValue || {}
      },
      set(val) {
        this.$emit('update:modelValue', structuredClone(toRaw(val)))
      }
    },
    groupedFields() {
      const grouped = this.availableCustomFields.reduce((acc, field) => {
        const section = field.section
        if (!acc[section]) {
          acc[section] = [];
        }
        acc[section].push(field);
        return acc;
      }, {});

      return grouped
    }
  },
  data() {
    return {
      emitModelUpdate: false,
      availableCustomFields: [],
      localValuesCopy: {}
    }
  }
}
</script>

<style scoped>

</style>
